import React, { useState } from "react";
import { GoogleReCaptchaProvider, useGoogleReCaptcha } from "react-google-recaptcha-v3";
import { postAd } from "../../api";
import "./PostAd.css";

const SITE_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY;

const PostAdForm = () => {
  const { executeRecaptcha } = useGoogleReCaptcha();

  const [form, setForm] = useState({
    title: "",
    price: "",
    snippet: "",
    description: "",
    phone: "",
    location: "",
  });

  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");

  const handleChange = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!executeRecaptcha) {
      setMessage("reCAPTCHA is not ready yet.");
      return;
    }

    // Get token from Google
    const captchaToken = await executeRecaptcha("post_ad");

    setLoading(true);

    try {
      await postAd({
        ...form,
        captcha: captchaToken, // send to backend
      });

      setMessage("Your ad was posted successfully!");

      setForm({
        title: "",
        price: "",
        snippet: "",
        description: "",
        phone: "",
        location: "",
      });

    } catch (err) {
      console.error(err);
      setMessage("Error posting your ad.");
    }

    setLoading(false);
  };

  return (
    <div className="post-ad-container">
      <h2>Post Your Ad</h2>

      {message && <p className="message">{message}</p>}

      <form onSubmit={handleSubmit} className="post-ad-form">
        <input type="text" name="title" placeholder="Ad Title *" value={form.title} onChange={handleChange} required />

        <input type="text" name="price" placeholder="Price *" value={form.price} onChange={handleChange} required />

        <input type="text" name="snippet" placeholder="Short Summary *" value={form.snippet} onChange={handleChange} required />

        <textarea name="description" placeholder="Full Description" value={form.description} onChange={handleChange}></textarea>

        <input type="text" name="phone" placeholder="Phone Number *" value={form.phone} onChange={handleChange} required />

        <input type="text" name="location" placeholder="Location *" value={form.location} onChange={handleChange} required />

        <button type="submit" disabled={loading}>
          {loading ? "Posting..." : "Post Ad"}
        </button>
      </form>
    </div>
  );
};

const PostAd = () => {
  return (
    <GoogleReCaptchaProvider reCaptchaKey={SITE_KEY}>
      <PostAdForm />
    </GoogleReCaptchaProvider>
  );
};

export default PostAd;
